import React from 'react'

export default function User({el, width}) {
    return (
        <div className="user" style={{width: width}}> 
        <div className="userImage" >
        <img src={el.img} alt=""/>
        </div>
        <h5>{el.name}</h5>
        </div>
    )
}
